import React, {FC} from 'react'

import {observer} from 'mobx-react-lite'

import {IRadioProps} from 'components/elements/fields/Radio/Radio'
import RadioGroup from 'components/elements/fields/Radio/RadioGroup'

interface IMobxRadioGroupProps extends IRadioProps {
	name: string
	label?: string
	options: readonly {
		value: string | number
		name?: string
	}[]
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: any
}

const MobxRadioGroup: FC<IMobxRadioGroupProps> = ({name, label, store, options, ...props}) => {
	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		store[name] = e.target.value
	}

	return (
		<RadioGroup
			name={name}
			label={label}
			options={options}
			storeValue={store[name]}
			onChange={onChange}
			{...props}
		/>
	)
}

MobxRadioGroup.displayName = 'MobxRadioGroup'

export default observer(MobxRadioGroup)
